import * as React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import {
  IconButton as RNPIconButton,
  IconButtonProps as RNPIconButtonProps,
} from 'react-native-paper';

type IconButtonProps = Omit<RNPIconButtonProps, 'style'> & {
  style?: StyleProp<ViewStyle>;
};

export default function IconButton(props: IconButtonProps) {
  return <RNPIconButton {...props} />;
}

export function BackButton({ onPress, style, ...props }: Omit<IconButtonProps, 'icon'>) {
  return (
    <IconButton
      icon="arrow-left"
      onPress={onPress}
      style={[styles.backButtonContainer, style]}
      {...props}
    />
  );
}

const styles = StyleSheet.create({
  backButtonContainer: {
    left: 0,
    position: 'absolute',
    top: 0,
    zIndex: 1,
  },
});
